export default "__VITE_ASSET__DnDWOjKS__"